// The app's colour on its sign-in page (`--app-brand`: the sign-in button). The app itself is drawn by
// the app (its frame); the shell draws no bar.
import { appInfo } from './session.ts';

export function applyBranding() {
  document.documentElement.style.setProperty('--app-brand', appInfo().branding.primaryColor ?? '#475569');
}
